import { TuringClientLogger } from "@turingenterprises/turing-client";
import getEnv from "../../services/util/getEnv";

export const turingLogger = new TuringClientLogger({
  baseApiUrl: getEnv("REACT_APP_LOGGING_SERVER_URL"),
  logName: 'VETTING',
});
